export const normalizeSearchParams = (searchParams: URLSearchParams): Record<string, string | string[]> => {
  const normalized: Record<string, string | string[]> = {}

  const keys = new Set<string>()
  for (const [key] of searchParams.entries()) {
    keys.add(key)
  }

  for (const key of keys) {
    const values = searchParams.getAll(key)
    if (values.length === 1) {
      normalized[key] = values[0]
    } else if (values.length > 1) {
      normalized[key] = values
    }
  }

  return normalized
}
